package org.maplibre.compose.logging

/** Severity of a [MapLogRecord], in ascending order. */
public enum class MapLogLevel {
  Debug,
  Info,
  Warning,
  Error,
}
